/**
 * IndustryBulkBar — quick bulk-map/unmap row.
 * One button per visible industry; maps or unmaps ALL filtered entities at once.
 */
import React from 'react';
import { useT } from '../../i18n/I18nContext.jsx';

export function IndustryBulkBar({ visibleIndustries, filteredTree, junction, onBulkToggle }) {
  const t = useT();
  if (!visibleIndustries.length) return null;

  return (
    <div className="industry-matrix-bulk-bar" style={{
      display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center',
      padding: '6px 10px', background: 'var(--surface-2)', borderRadius: 6,
      border: '1px solid var(--erp-border, #e2e8f0)', fontSize: 12
    }}>
      <span style={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginRight: 4 }}>
        {t('erp.industryMatrix.bulkMapLabel', 'Bulk Map filtered rows →')}
      </span>
      {visibleIndustries.slice(0, 8).map(ind => {
        const getAllFilteredIds = (type) => {
          const ids = [];
          filteredTree.forEach(m => {
            if (type === 'Module' && !m._hideModuleRow) ids.push(String(m.ModuleId));
            (m.subModules || []).forEach(s => {
              if (type === 'SubModule') ids.push(String(s.SubModuleId));
              (s.screens || []).forEach(sc => { if (type === 'Screen') ids.push(String(sc.SeqId)); });
            });
            (m.directScreens || []).forEach(sc => { if (type === 'Screen') ids.push(String(sc.SeqId)); });
          });
          return ids;
        };
        const allIds = [
          ...getAllFilteredIds('Module'),
          ...getAllFilteredIds('SubModule'),
          ...getAllFilteredIds('Screen'),
        ];
        const mSet = junction[ind.IndustryCode];
        const mappedCount = allIds.filter(id =>
          mSet && (mSet.Module?.has(id) || mSet.SubModule?.has(id) || mSet.Screen?.has(id))
        ).length;
        const allMapped = allIds.length > 0 && mappedCount === allIds.length;

        return (
          <button
            key={ind.IndustryCode}
            className="erp-btn"
            onClick={() => onBulkToggle(ind.IndustryCode, allMapped, filteredTree)}
            data-testid={`industry-matrix-bulk-${ind.IndustryCode}`}
            title={allMapped
              ? `Unmap all ${allIds.length} filtered entities from ${ind.IndustryName}`
              : `Map all ${allIds.length} filtered entities to ${ind.IndustryName}`}
            style={{
              fontSize: 12, padding: '3px 8px',
              background:  allMapped ? 'rgba(59,130,246,0.12)' : undefined,
              borderColor: allMapped ? '#1d4ed8' : undefined,
              color:       allMapped ? '#1d4ed8' : undefined,
              fontWeight: 700,
            }}
          >
            {allMapped ? '−' : '+'} {ind.IndustryCode}
            {allIds.length > 0 && (
              <span style={{ opacity: 0.6, marginLeft: 3 }}>({mappedCount}/{allIds.length})</span>
            )}
          </button>
        );
      })}
      {visibleIndustries.length > 8 && (
        <span style={{ color: '#94a3b8', fontSize: 12 }}>
          +{visibleIndustries.length - 8} {t('erp.industryMatrix.moreIndustries', 'more industries…')}
        </span>
      )}
    </div>
  );
}
